export enum UtmMediumValues {
	CPC = 'cpc',
	CPC_SOCIAL = 'cpc_social',
	EMAIL = 'email',
	SEA = 'SEA'
}

export enum UtmSourceValues {
	GOOGLE = 'google',
	CIO = 'cio',
	TIKTOK = 'tiktok',
	FACEBOOK = 'facebook',
	INSTAGRAM = 'instagram'
}